import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';
import { Snackbar } from '@scramble/ui';
import i18n from '@/i18n';

const { t } = i18n;

export const useCancelWithdrawRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reqId =>
      cashService
        .cancelWithdrawRequest(reqId)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            Snackbar({
              type: 'success',
              text: t('withdraw:withdrawals_history.withdraw_cancelled'),
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.withdraw_info],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.withdraw_history],
            });
            return { data, success: true };
          }
          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
